module.exports = __webpack_public_path__ + "img/bolsas.ba676700.png";